import { useDispatch } from "react-redux";
import { CEO_TYPES } from "../../constants/AppConstants";
import useAuth from "../../hooks/useAuth";
import ReviewList from "./ReviewList";
import ReviewSearch from "./ReviewSearch";
import SpecialReviewOnlyForPremium from "./SpecialReviewOnlyForPremium";

const SpecialReview = function () {
  const { ceoInfo } = useAuth();
  const dispatch = useDispatch();
  const ceoType = ceoInfo?.ceo_type;

  if (ceoType === CEO_TYPES.NORMAL) {
    return (
      <div className="flex flex-col">
        <SpecialReviewOnlyForPremium />
      </div>
    );
  }

  const onSubmitSearch = () => {};

  return (
    <div className="flex flex-col">
      <ReviewSearch onSubmitSearch={onSubmitSearch} />
      <ReviewList />
    </div>
  );
};
export default SpecialReview;
